import Block from "base/Block";

class TextAccordion extends Block {
	static get blockName() {
		return 'b-text-accordion';
	}

	onInit() {
		let mobileHiddenText = this.el.querySelector('.l-text--mobile-hidden');

		if (mobileHiddenText && window.innerWidth < 430) {
			mobileHiddenText.style.maxHeight = 0;

			let mobileHiddenTextButton = this.el.querySelector('.l-button--hidden-text');
			mobileHiddenTextButton.classList.remove('hidden');

			mobileHiddenTextButton.addEventListener('click', () => {
				mobileHiddenText.style.maxHeight = mobileHiddenText.scrollHeight + 'px';
				mobileHiddenTextButton.classList.add('hidden');
			})
		}

		let items = this.el.querySelectorAll('.' + this.blockName + '__item');

		if (items) {
			const itemBottomPaddingTop = window.innerWidth < 430 ? 10: 14;
			items.forEach(item => {
				let itemBottom = item.querySelector('.' + this.blockName + '__item-bottom');
				itemBottom.style.maxHeight = 0;

				item.addEventListener('click', () => {
					if (item.classList.contains('open')) {
						item.classList.remove('open');
						itemBottom.style.maxHeight = 0;
					}
					else {
						item.classList.add('open');
						itemBottom.style.maxHeight = itemBottomPaddingTop + +itemBottom.scrollHeight + 'px';
					}
				})
			});

			items[0].classList.add('open');
			let firstItemBottom = items[0].querySelector('.' + this.blockName + '__item-bottom');
			firstItemBottom.style.maxHeight = itemBottomPaddingTop + +firstItemBottom.scrollHeight + 'px';
		}
	}
}

Block.register(TextAccordion);

export default TextAccordion;
